import { PATHS } from '@/constants/routes';
import shallow from 'zustand/shallow';
import { useAuth } from '../state';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

const protectedRoute = [PATHS.USER_AREA, PATHS.USER_AREA_WALLET];

export const useRouterProtector = (): void => {
  const router = useRouter();
  const user = useAuth(s => s.user, shallow);
  const checkIfAuthenticated = (): boolean => {
    return !!(user && user.token);
  };

  const checkRouteType = (currentRoute: string, protectedRoutes: string[]) => {
    return protectedRoutes.includes(currentRoute);
  };

  useEffect(() => {
    if (checkRouteType(router.asPath, protectedRoute) && !checkIfAuthenticated()) {
      router.replace('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
